import util from './util.js'
//v1.0.0

//const pre_url = "http://192.168.2.4:5152";
//const pre_url = "http://192.168.110.172:5152";
const pre_url = "http://192.168.11.83:5152";

async function getAllMachines(){
	let url = pre_url + "/getAllMachines";
  return await util.request(url);
}

async function getMessageByPage(accessType,currentPage, limit, options, order,haveOr){
  let url = pre_url + "/getMessageByPage";
  return await util.request(url, {accessType,currentPage, limit, options, order,haveOr},'POST');
}

async function deleteMachine(machineId){
	let url = pre_url + "/deleteMachine";
  return await util.request(url, {machineId});
}

async function insertMachine(machine){
	let url = pre_url + "/insertMachine";
  return await util.request(url, {machine}, 'POST');
}

async function updateMachine(machine){
	let url = pre_url + "/updateMachine";
  return await util.request(url, {machine}, 'POST');
}

async function getUsersByPage(currentPage,limit,options){
	let url = pre_url + "/getUsersByPage";
  return await util.request(url, {currentPage, limit, options});
}

async function searchUser(searchParam){
	let url = pre_url + "/searchUser";
  return await util.request(url, {searchParam});
}

async function borrowMachine(borrowData){
	let url = pre_url + "/borrowMachine";
  return await util.request(url, {borrowData}, 'POST');
}

async function returnMachine(returnData){
	let url = pre_url + "/returnMachine";
  return await util.request(url, {returnData}, 'POST');
}

async function returnMachineByUser(returnData){
	let url = pre_url + "/returnMachineByUser";
  return await util.request(url, {returnData}, 'POST');
}

async function processMachine(processData){
	let url = pre_url + "/processMachine";
  return await util.request(url, {processData}, 'POST');
}

async function insertVerification(verification){
	let url = pre_url + "/insertVerification";
  return await util.request(url, {verification}, 'POST');
}

async function updateVerification(verification){
	let url = pre_url + "/updateVerification";
  return await util.request(url, {verification}, 'POST');
}

async function getChangeLogByPage(currentPage,limit,options){
	let url = pre_url + "/getChangeLogByPage";
  return await util.request(url, {currentPage, limit, options});
}

async function insertMaintenance(maintenance){
	let url = pre_url + "/insertMaintenance";
  return await util.request(url, {maintenance}, 'POST');
}

async function getMaintenanceByPage(currentPage,limit,options,starttime,endtime){
	let url = pre_url + "/getMaintenanceByPage";
  return await util.request(url, {currentPage, limit, options, starttime, endtime});
}

async function insertAuthorization(authorization){
	let url = pre_url + "/insertAuthorization";
  return await util.request(url, {authorization}, 'POST');
}

async function getAuthorizationByPage(currentPage,limit,options,starttime,endtime){
	let url = pre_url + "/getAuthorizationByPage";
  return await util.request(url, {currentPage, limit, options, starttime, endtime});
}

async function insertAccessories(accessories){
	let url = pre_url + "/insertAccessories";
  return await util.request(url, {accessories}, 'POST');
}

async function getAccessoriesByPage(currentPage,limit,options,starttime,endtime){
	let url = pre_url + "/getAccessoriesByPage";
  return await util.request(url, {currentPage, limit, options, starttime, endtime});
}

async function insertExamination(examination){
	let url = pre_url + "/insertExamination";
  return await util.request(url, {examination}, 'POST');
}

async function getExaminationByPage(currentPage,limit,options,starttime,endtime){
	let url = pre_url + "/getExaminationByPage";
  return await util.request(url, {currentPage, limit, options, starttime, endtime});
}

async function getExaminationPlanByPage(currentPage,limit,options,starttime,endtime){
	let url = pre_url + "/getExaminationPlanByPage";
  return await util.request(url, {currentPage, limit, options, starttime, endtime});
}

async function insertExaminationPlan(examination){
	let url = pre_url + "/insertExaminationPlan";
  return await util.request(url, {examination}, 'POST');
}

async function updateExaminationPlan(examination){
	let url = pre_url + "/updateExaminationPlan";
  return await util.request(url, {examination}, 'POST');
}

async function deleteExaminationPlan(planId){
	let url = pre_url + "/deleteExaminationPlan";
  return await util.request(url, {planId});
}

async function getExaminationIntermediateByPage(currentPage,limit,options,starttime,endtime){
	let url = pre_url + "/getExaminationIntermediateByPage";
  return await util.request(url, {currentPage, limit, options, starttime, endtime});
}

async function insertExaminationIntermediate(examination){
	let url = pre_url + "/insertExaminationIntermediate";
  return await util.request(url, {examination}, 'POST');
}

async function updateExaminationIntermediate(examination){
	let url = pre_url + "/updateExaminationIntermediate";
  return await util.request(url, {examination}, 'POST');
}

async function deleteExaminationIntermediate(planId){
	let url = pre_url + "/deleteExaminationIntermediate";
  return await util.request(url, {planId});
}

async function getTraceabilityByPage(currentPage,limit,options,starttime,endtime){
	let url = pre_url + "/getTraceabilityByPage";
  return await util.request(url, {currentPage, limit, options, starttime, endtime});
}

async function insertTraceability(traceability){
	let url = pre_url + "/insertTraceability";
  return await util.request(url, {traceability}, 'POST');
}

async function updateTraceability(traceability){
	let url = pre_url + "/updateTraceability";
  return await util.request(url, {traceability}, 'POST');
}

async function deleteTraceability(traceabilityId){
	let url = pre_url + "/deleteTraceability";
  return await util.request(url, {traceabilityId});
}

async function getTraceabilityConfirmByPage(currentPage,limit,options,starttime,endtime){
	let url = pre_url + "/getTraceabilityConfirmByPage";
  return await util.request(url, {currentPage, limit, options, starttime, endtime});
}

async function insertTraceabilityConfirm(traceability){
	let url = pre_url + "/insertTraceabilityConfirm";
  return await util.request(url, {traceability}, 'POST');
}

async function updateTraceabilityConfirm(traceability){
	let url = pre_url + "/updateTraceabilityConfirm";
  return await util.request(url, {traceability}, 'POST');
}

async function deleteTraceabilityConfirm(confirmId){
	let url = pre_url + "/deleteTraceabilityConfirm";
  return await util.request(url, {confirmId});
}

async function downloadFile(searchTable,options){
	//console.log(options);
	let url = pre_url + "/file/download";
  return await util.request(url, {searchTable, options}, 'POST', 'blob');
}

async function getNewMachineNO(machineType){
	let url = pre_url + "/getNewMachineNO";
  return await util.request(url, {machineType});
}

async function getDepartMentList(options){
	let url = pre_url + "/getDepartMentList";
  return await util.request(url, {options});
}

async function requireMachine(operationData){
	let url = pre_url + "/requireMachine";
  return await util.request(url, {operationData}, 'POST');
}

async function getUserInfo(){
	let url = pre_url + "/getUserInfo";
  return await util.request(url, {});
}

async function login(loginName,code){
	let url = pre_url + "/login";
  return await util.request(url, {loginName, code}, 'POST');
}

async function revoke(processData){
	let url = pre_url + "/revoke";
  return await util.request(url, {processData}, 'POST');
}

async function updateUsersPhone(){
  let url = pre_url + "/updateUsersPhone";
  return await util.request(url,{},'POST');
}

async function checkNewMachineNO(newMachineNO){
  let url = pre_url + "/checkNewMachineNO";
  return await util.request(url,{newMachineNO});
}

async function dropFile(filepath){
  let url = pre_url + "/dropFile";
  return await util.request(url,{urls: filepath});
}

async function getAlertCount(alertConfig,userId){
  let url = pre_url + "/getAlertCount";
  return await util.request(url,{alertConfig},'POST');
}

async function getStatistics(){
  let url = pre_url + "/getStatistics";
  return await util.request(url,{},'POST');
}

async function sendEmail(data,month,owner){
  let url = pre_url + "/sendEmail";
  return await util.request(url,{data,month,owner},'POST');
}

async function getCompany(filepath){
  let url = pre_url + "/getCompany";
  return await util.request(url,{filepath},'POST');
}

async function getDirectories(nextPath){
  let url = pre_url + "/getDirectories";
  return await util.request(url,{nextPath: nextPath||""});
}

async function sendCode(user){
  let url = pre_url + "/sendCode";
  return await util.request(url,{user},'POST');
}

async function checkToken(){
	let url = pre_url + "/checkToken";
  return await util.request(url,{});
}

export default {
	pre_url,
	getAllMachines,
  getMessageByPage,

	deleteMachine,
	insertMachine,
	updateMachine,
	getUsersByPage,
	searchUser,
	borrowMachine,
	returnMachine,
	processMachine,
	insertVerification,
	updateVerification,
	getChangeLogByPage,
	insertMaintenance,
	getMaintenanceByPage,
	getAuthorizationByPage,
	insertAuthorization,
	downloadFile,
	insertAccessories,
	getAccessoriesByPage,
	getExaminationByPage,
	insertExamination,
	getNewMachineNO,
	getDepartMentList,
	requireMachine,
	returnMachineByUser,
	getUserInfo,
	login,
	revoke,
  updateUsersPhone,
  checkNewMachineNO,
  dropFile,
  getAlertCount,
  getStatistics,
  checkToken,

	getExaminationPlanByPage,
	insertExaminationPlan,
	updateExaminationPlan,
	deleteExaminationPlan,

	getExaminationIntermediateByPage,
	insertExaminationIntermediate,
	updateExaminationIntermediate,
	deleteExaminationIntermediate,

	getTraceabilityByPage,
	insertTraceability,
	updateTraceability,
	deleteTraceability,
	getTraceabilityConfirmByPage,
	insertTraceabilityConfirm,
	updateTraceabilityConfirm,
	deleteTraceabilityConfirm,

	sendEmail,
	getCompany,
	getDirectories,

	sendCode

}



//////////////////
// WEBPACK FOOTER
// ./static/equipmentdata.js
// module id = null
// module chunks = 